export default __webpack_public_path__ + "static/media/CodeBackground.59a22e4a.jfif";